module.exports = __webpack_public_path__ + "static/media/rw.d724e841.svg";